// Edit → show form
$(document).on('click', '.edit-brand-director-btn-js', function () {
  const $container = $(this).closest('.brand-director-container');
  $container.find('.brand-director-display').addClass('d-none');
  $container.find('.update-brand-director-form').removeClass('d-none');
});

// Pick director → auto-submit
$(document).on('change', '.update-brand-director-form .select-brand-director', function () {
  const form = $(this).closest('form').get(0);
  if (!form) return;

  if (typeof form.requestSubmit === 'function') {
    form.requestSubmit();
    return;
  }

  window.Rails.fire(form, 'submit');
});

// Success → reload the component so the server renders the updated director state
$(document).on('ajax:success', '.update-brand-director-form', function (event, data) {
  const responseData = data || event.detail?.[0] || {};
  if (responseData.success) {
    reloadComponent($(this));
    return;
  }

  if (responseData.error) alert(responseData.error);
});

// Error → notify
$(document).on('ajax:error', '.update-brand-director-form', function (_e, xhr) {
  const message = (xhr.responseJSON && xhr.responseJSON.error) || 'Something went wrong.';
  alert(message);
});

$(document).ready(function() {
  // Removing active brands modal --------------------------------------------------------------------
  $(document).on('click', '.remove-active-brand-btn-js', function() {
    const currentModal = $(this).closest('.single-brand-container').find('.active-brand-removal-modal');
    currentModal.modal('show');
  });
});
